/**
 * @fileoverview GET handler for the "/engagement/campaigns/campaigns_with_push_buttons" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementCampaignsCampaignsWithPushButtons } from "./constants";
import type { EngagementCampaignsCampaignsWithPushButtonsResult } from "./types";

export const getEngagementCampaignsCampaignsWithPushButtons = reactQueryFetcherAdapter(
  engagementCampaignsCampaignsWithPushButtons,
  (
    signal: AbortSignal,
    appGroupId: string,
    query: string,
    limit: number
  ): Promise<EngagementCampaignsCampaignsWithPushButtonsResult[]> => {
    return fetch(
      "/engagement/campaigns/campaigns_with_push_buttons",
      "GET",
      { app_group_id: appGroupId, query, limit },
      { signal }
    );
  }
);
